import { VStack, Flex, Divider, Box } from "@chakra-ui/react";
import { ReactNode } from "react";

export default function CampaignSidebar({
  heading,
  title,
  children,
}: {
  heading: ReactNode;
  title: ReactNode;
  children: ReactNode;
}) {
  return (
    <VStack
      minWidth="410px"
      maxWidth="410px"
      spacing="0"
      alignItems="flex-start"
      bg="oneOffs.backgroundGray"
    >
      <Flex w="100%" pt="12px" px="20px">
        {heading}
      </Flex>

      <VStack w="100%" spacing="0" py="2" alignItems="unset">
        <Box px="5" w="100%">
          {title}
        </Box>
        <Divider height="1px" bg="gray.400" mt="10px !important" />
        <VStack
          w="100%"
          spacing="5"
          overflowX="hidden"
          overflowY="auto"
          alignItems="unset"
          px="5"
          py="3"
          maxHeight="calc(100vh - 145px)"
          minHeight="calc(100vh - 105px)"
        >
          {children}
        </VStack>
      </VStack>
    </VStack>
  );
}
